import {Modal} from 'antd'
import {ChannelIcon} from 'components/icons/ChannelIcon'
import {WithDetailPopup} from 'components/WithDetailPopup'
import {createAliasTransform} from 'helpers/createAliasTransform'
import getLinkToDetail from 'helpers/getLinkToDetail'
import _ from 'lodash'
import React, {useContext} from 'react'
import {Link} from 'react-router-dom'
import {NullAsDefault} from 'views/Shared'
import AskContentLayout from './Ask/AskContentLayout'
import AskContentMeta from './Ask/AskContentMeta'
import AskContentWrapper from './Ask/AskContentWrapper'
import AskFooter from './Ask/AskFooter'
import {DetailAskContent} from './Ask/DetailAskContent'
import {
    DetailFeedContent,
    FeedContent,
    FeedContentLayout,
    FeedContentMeta,
    FeedFooter,
    FeedWrapper,
    withFeedContext,
} from './FeedCard'
import FeedContainerStateless from './FeedContainerStateless'
import FeedContext from './FeedContext'
import {FeedProvider} from './FeedProvider'
import {PiTrash} from "react-icons/pi";

const alias = {
    creatorId: ['creator.username', 'creator.idname', 'creator.id'],
    photos: 'photos',
    embed_data: 'embed_data',
    embed: 'embed',
    content_data: 'content_data',
    created: 'created',
    creatorType: 'creator._type',
    creatorName: 'creator.name',
    title: ['title', 'name'],
    description: 'description',
    cover: 'cover_photo',
    id: 'id',
    type: '_type',
}

export const transformAlias = createAliasTransform(alias)
export const allActions = {
    to: true,
    pin: true,
    unpin: true,
    bookmark: true,
    vote: true,
    voteUp: false,
    voteDown: false,
    message: true,
    view: true,
    share: true,
    copy_link: true,
    edit: true,
    delete: true,
}
const Container = withFeedContext(FeedContainerStateless)

export const defaultComponents = {
    Container,
    Wrapper: FeedWrapper,
    ContentLayout: FeedContentLayout,
    ContentMeta: FeedContentMeta,
    Content: FeedContent,
    Footer: FeedFooter,
}

export const defaultDetailComponents = {
    Container,
    Wrapper: FeedWrapper,
    ContentLayout: FeedContentLayout,
    ContentMeta: FeedContentMeta,
    Content: DetailFeedContent,
    Footer: FeedFooter,
}

export const askDetailComponents = {
    Container,
    Wrapper: AskContentWrapper,
    ContentLayout: AskContentLayout,
    ContentMeta: AskContentMeta,
    Content: DetailAskContent,
    Footer: AskFooter,
}

const renderDeleted = (
    item,
    {Wrapper, ContentLayout, ContentMeta, Content, Footer}
) => {
    return null
}

export const showConfirm = ({
                                icon = <PiTrash className="anticon"/>,
                                title = 'Are you sure delete this task?',
                                content,
                                okText = 'Yes',
                                okType = 'danger',
                                cancelText = 'No',
                                onOk = () => {
                                    console.log('OK')
                                },
                                onCancel = () => {
                                    console.log('Cancel')
                                },
                                ...props
                            } = {}) =>
    Modal.confirm({
        icon,
        title,
        content,
        okText,
        okType,
        cancelText,
        onOk,
        onCancel,
        ...props,
    })
export const createTimeLineFeed = (
    customComponents = {},
    defaultActions = allActions
) => {
    const components = {
        ...defaultComponents,
        ...customComponents,
    }
    const {
        Footer = NullAsDefault,
        Wrapper = NullAsDefault,
        Content = NullAsDefault,
        ContentMeta = NullAsDefault,
        ContentLayout = NullAsDefault,
    } = components

    return function TimelineFeed({item, detail = false, children}) {
        if (!item) return null

        return (
            <FeedProvider
                item={item}
                detail={detail}
                defaultActions={defaultActions}>
                {children ? (
                    children
                ) : item.isDeleted || item.deleted ? (
                    renderDeleted(item, components)
                ) : (
                    <Wrapper>
                        <ContentLayout>
                            <ContentMeta/>
                            <Content/>
                            <Footer/>
                        </ContentLayout>
                    </Wrapper>
                )}
            </FeedProvider>
        )
    }
}

export const DetailAsk = createTimeLineFeed(askDetailComponents, {
    ...allActions,
    vote: false,
    // voteUp: true,
    // voteDown: true,
    to: false,
    message: false,
})

export const DetailFeed = createTimeLineFeed(defaultDetailComponents, {
    ...allActions,
    to: false,
    message: false,
})

export const FeedCard = createTimeLineFeed(
    {
        Container: () => {
            const {item} = useContext(FeedContext)
            return (
                <div className="mb-1 text-color-300 flex items-center justify-start">
                    <ChannelIcon
                        premium={_.get(item, 'container.premium', 0)}
                        className="mr-2 text-color-100 text-3xl w-8 h-8"
                    />
                    <Link
                        to={getLinkToDetail(item.container)}
                        className="cursor-pointer hover:underline">
                        {_.get(item, 'container.title') || _.get(item, 'container.name')}
                    </Link>
                </div>
            )
        },
        Content: () => <FeedContent className="p-3 md:p-4"/>,
        ContentLayout: ({style, children}) => {
            return (
                <div style={style}
                     className="custom-item-render background border-t border-color-50 shadow-md rounded-xl">
                    {children}
                </div>
            )
        },
    },
    {
        ...allActions,
        bookmark: true,
        // pin: false,
        // unpin: false,
    }
)


export const SearchingFeedCard = createTimeLineFeed(
    {
        Container: () => {
            const {item} = useContext(FeedContext)
            return (
                <div className="mb-1 text-color-300 flex items-center justify-start">
                    <ChannelIcon
                        premium={_.get(item, 'container.premium', 0)}
                        className="mr-2 text-color-100 text-3xl w-8 h-8"
                    />
                    <Link
                        to={getLinkToDetail(item.container)}
                        className="cursor-pointer hover:underline">
                        {_.get(item, 'container.title') || _.get(item, 'container.name')}
                    </Link>
                </div>
            )
        },
        Footer: () => null,
        Content: () => <FeedContent className="p-3 md:p-4"/>,
        ContentLayout: ({style, children}) => {
            return (
                <div style={style}
                     className="custom-item-render background shadow-md hover:shadow-lg rounded-xl transition-shadow">
                    {children}
                </div>
            )
        },
    },
    {
        bookmark: true
    }
)

export const EmbedFeedCard = createTimeLineFeed(
    {
        Container: () => {
            const {item} = useContext(FeedContext)
            return (
                <div className="mb-1 text-color-300 flex items-center justify-start bg-gray-50">
                    <ChannelIcon
                        premium={_.get(item, 'container.premium', 0)}
                        className="mr-2 text-color-100 text-3xl w-8 h-8"
                    />
                    <Link
                        to={getLinkToDetail(item?.container)}
                        className="cursor-pointer hover:underline">
                        {_.get(item, 'container.title') || _.get(item, 'container.name')}
                    </Link>
                </div>
            )
        },
        Content: () => <FeedContent className="EmbedFeedCardContent"/>,
        ContentLayout: ({style, children}) => {
            return (
                <div style={style} className="FeedCardContentEmbed">
                    {children}
                </div>
            )
        },
        Footer: NullAsDefault
    },
    {}
)

export const WoGFeedCard = createTimeLineFeed(
    {
        Container: NullAsDefault,
        Content: () => <FeedContent className="mx-2 mb-2 shadow rounded-lg"/>,
        ContentLayout: ({style, children}) => {
            return (
                <div
                    style={style}
                    className="flex flex-col FeedCardWordGod">
                    {children}
                </div>
            )
        },
    },
    {}
)

export const UserCheckinFeedCard = createTimeLineFeed(
    {
        Container: NullAsDefault,
        Content: () => <FeedContent className="mx-2 mb-2 shadow rounded-lg"/>,
        ContentLayout: ({style, children}) => {
            return (
                <div
                    style={style}
                    className="flex flex-col UserCheckinFeedCard">
                    {children}
                </div>
            )
        },
        ContentMeta: NullAsDefault,
        Footer: NullAsDefault

    },
    {}
)


export const AnnouncementFeedCard = createTimeLineFeed(
    {
        Container: NullAsDefault,
        Content: () => <FeedContent className="mx-2 mb-2 shadow rounded-lg"/>,
        ContentLayout: ({style, children}) => {
            return (
                <div
                    style={style}
                    className="flex flex-col AnnouncementFeedCard">
                    {children}
                </div>
            )
        },
        ContentMeta: NullAsDefault,
        Footer: NullAsDefault

    },
    {}
)


export const EventFeed = createTimeLineFeed({
    Container: NullAsDefault,
})

export const ChannelFeed = createTimeLineFeed({
    Container: NullAsDefault,
    Content: () => <FeedContent className="p-3 md:p-4 ChannelFeed"/>,
    ContentLayout: ({style, children}) => {
        return (
            <div style={style}
                 className="custom-item-render background border-t border-color-50 shadow-md rounded-xl">
                {children}
            </div>
        )
    },
})

export const ChannelNewsFeed = createTimeLineFeed({
    Container: () => (
        <FeedContext.Consumer>
            {({item}) => (
                <WithDetailPopup
                    item={item.container}
                    id={item.container}
                    style={{
                        textOverflow: 'ellipsis',
                    }}>
          <span className=" font-bold flex items-center whitespace-no-wrap mr-2 cursor-pointer hover:underline">
            <span className="mr-2">
              <ChannelIcon
                  className="mr-2  text-3xl w-8 h-8"
                  premium={_.get(item, 'container.premium', 0)}
              />
            </span>
            <span className="truncate flex-1">{item.container.title}</span>
          </span>
                </WithDetailPopup>
            )}
        </FeedContext.Consumer>
    ),
    ContentLayout: ({style, children}) => {
        return (
            <div style={style}
                 className="custom-item-render background border-t border-color-50 shadow-md rounded-xl">
                {children}
            </div>
        )
    },
})

export const CategoryNewsFeed = createTimeLineFeed({
    Container: () => (
        <FeedContext.Consumer>
            {({item}) => (
                <WithDetailPopup
                    item={item.container}
                    id={item.container}
                    style={{
                        textOverflow: 'ellipsis',
                    }}>
          <span className=" font-bold flex items-center whitespace-no-wrap mr-2 cursor-pointer hover:underline">
            <span className="mr-2">
              <ChannelIcon
                  className="mr-2 text-color-100 text-3xl w-8 h-8"
                  premium={_.get(item, 'container.premium', 0)}
              />
            </span>
            <span className="truncate flex-1">{item.container.title}</span>
          </span>
                </WithDetailPopup>
            )}
        </FeedContext.Consumer>
    ),
    // ContentLayout: (props) => <FeedContentLayout {...props} />,
    ContentLayout: ({style, children}) => {
        return (
            <div style={style}
                 className="custom-item-render background border-t border-color-50 shadow-md rounded-xl">
                {children}
            </div>
        )
    },
})

const TimelineFeed = createTimeLineFeed()

export default TimelineFeed
